






import { Component, Prop, Vue } from 'vue-property-decorator';
import { Wrapper as MarkupWrapper } from '@/components/markup';

@Component({
  components: {
    MarkupWrapper,
  },
})
export default class ComponentsLayoutExtra extends Vue {
  // props
  @Prop({ type: String, default: '', })
  bg: string;

  @Prop({ type: Boolean, default: false })
  marginBottom: boolean;

  get classes() {
    const { bg, marginBottom } = this;
    return {
      [`bg_${bg}`]: true,
      'layout_bottom': marginBottom
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/layout/Extra.vue